import { jsx as i, jsxs as c } from "react/jsx-runtime";
import { createContext as b, forwardRef as u, useMemo as f, useContext as p } from "react";
import { faXmark as y } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as v } from "@fortawesome/react-fontawesome";
import { twMerge as a } from "tailwind-merge";
const d = b({
  size: "md",
  color: "neutral",
  variant: "pill"
}), h = u(
  ({
    size: r = "md",
    color: e = "neutral",
    variant: n = "pill",
    className: l,
    children: t,
    onClose: o,
    ...s
  }, m) => {
    const x = f(() => ({ size: r, color: e, variant: n }), [r, e, n]);
    return /* @__PURE__ */ i(d.Provider, { value: x, children: /* @__PURE__ */ c(
      "div",
      {
        className: a(
          "flex items-center gap-1 text-sm font-medium",
          //
          e === "neutral" && "bg-gray-50 text-gray-700",
          e === "primary" && "bg-blue-50 text-blue-700",
          e === "error" && "bg-red-50 text-red-700",
          e === "warning" && "bg-orange-50 text-orange-700",
          e === "success" && "bg-green-50 text-green-700",
          //
          n === "pill" && "rounded-full",
          n === "rounded" && "rounded-md",
          //
          r === "sm" && "px-2 py-0.5 text-xs",
          r === "md" && "px-2.5 py-0.5",
          r === "lg" && "px-3 py-1",
          //
          l
        ),
        ref: m,
        ...s,
        children: [
          t,
          o && /* @__PURE__ */ i(g, { onClick: o })
        ]
      }
    ) });
  }
);
h.displayName = "Badge";
const g = u(
  ({ className: r, type: e = "button", ...n }, l) => {
    const { color: t, variant: o, size: s } = p(d);
    return /* @__PURE__ */ i(
      "button",
      {
        ref: l,
        "aria-label": "Close",
        type: e,
        className: a(
          "-mr-1.5 flex size-4 items-center justify-center leading-none outline-none",
          //
          s === "sm" && "size-3.5",
          //
          t === "neutral" && "text-gray-400 hover:bg-gray-200 focus-visible:outline-gray-400",
          t === "primary" && "text-blue-400 hover:bg-blue-100 focus-visible:outline-blue-400",
          t === "error" && "text-red-400 hover:bg-red-100 focus-visible:outline-red-400",
          t === "warning" && "text-orange-400 hover:bg-orange-100 focus-visible:outline-orange-400",
          t === "success" && "text-green-400 hover:bg-green-100 focus-visible:outline-green-400",
          //
          o === "pill" && "rounded-full",
          o === "rounded" && "rounded-sm",
          //
          r
        ),
        ...n,
        children: /* @__PURE__ */ i(
          v,
          {
            icon: y,
            className: a("size-3 text-inherit", s === "sm" && "size-2.5")
          }
        )
      }
    );
  }
);
g.displayName = "BadgeClose";
export {
  h as Badge,
  d as BadgeContext
};
